import type { Options } from '@/models/selectBox';

export const GUEST_TYPES = [
  { label: 'As an individual', value: 'individual' },
  { label: 'As a business', value: 'company' },
] as const;

export const GUEST_TYPE_OPTIONS: Options = GUEST_TYPES.map((type) => {
  return {
    label: type.label,
    value: type.value,
    disabled: false,
  };
});

export type GuestType = (typeof GUEST_TYPES)[number];
